module.exports = __webpack_public_path__ + "static/media/stalkx_greyscale.9af29592.jpg";